import { Icon28AddSquareOutline, Icon28CloudArrowUpOutline, Icon28PictureOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import imageCloud from 'img/Fullscreen/cloud_mailspace_full_x2.png';
import label30days from 'img/Fullscreen/label30days.png';
import label73 from 'img/Fullscreen/label73.png';
import { ReactComponent as Logo } from 'img/Fullscreen/Logo.svg';
import imgNew from 'img/Fullscreen/new.png';
import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import {
    cloudFullscreenB,
    cloudFullscreenC,
    cloudFullscreenD,
    cloudFullscreenE,
    fullscreenTariffId,
} from 'reactApp/appHelpers/featuresHelpers/features/fullscreen';
import { loadProductsAndOpenFastCheckout } from 'reactApp/modules/payment/payment.module';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { Screen } from 'reactApp/ui/Screen/Screen';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FullScreenMonetization.css';

type FullScreenMonetizationProps = {
    onClose?: () => void;
    onShow?: () => void;
};

const sendAnalytics = (action) => {
    sendDwh({
        eventCategory: 'fullscreen',
        action,
        dwhData: { name: 'mnz_mail_space', tariff: fullscreenTariffId },
    });
};

export const FullScreenMonetization = memo<FullScreenMonetizationProps>(({ onClose, onShow }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        sendAnalytics('show');
        emitAnalyticEvent(AnalyticEventNames.FULLSCREEN_SHOW);
        onShow?.();
    }, []);

    const onCloseScreen = useCallback(() => {
        sendAnalytics('close');
        emitAnalyticEvent(AnalyticEventNames.FULLSCREEN_CLOSE);
        onClose?.();
    }, [onClose]);

    const handleClickBye = useCallback(() => {
        sendAnalytics('click-full');
        emitAnalyticEvent(AnalyticEventNames.FULLSCREEN_CLICK_ALL);
        dispatch(
            loadProductsAndOpenFastCheckout({
                productId: fullscreenTariffId,
                paySource: 'mail_space_fullscreen_cloud',
                hideOtherTariffs: true,
            })
        );
    }, [dispatch]);

    const handleClickByeButton = useCallback(
        (event) => {
            event.stopPropagation();
            sendDwh({
                eventCategory: 'fullscreen',
                action: 'click',
                dwhData: { name: 'mnz_mail_space', tariff: fullscreenTariffId, button_name: 'get_tariff' },
            });
            emitAnalyticEvent(AnalyticEventNames.FULLSCREEN_CLICK);
            dispatch(
                loadProductsAndOpenFastCheckout({
                    productId: fullscreenTariffId,
                    paySource: 'mail_space_fullscreen_cloud',
                    hideOtherTariffs: true,
                })
            );
        },
        [dispatch]
    );

    return (
        <Screen
            onClose={onCloseScreen}
            withLogo={false}
            aboveAll={false}
            className={styles.screen}
            contentClassName={classNames(styles.screenContent)}
        >
            <div className={styles.root} onClick={handleClickBye}>
                <div className={styles.textBox}>
                    <div className={styles.logo}>
                        <Logo width={'100%'} />
                    </div>
                    <div className={styles.title}>Прокачайте Облако с&nbsp;подпиской Mail&nbsp;Space</div>
                    <ul className={styles.list}>
                        <li className={styles.item}>
                            <Icon28AddSquareOutline />
                            <p className={styles.text}>У&nbsp;вас будут дополнительные 256&nbsp;ГБ для&nbsp;хранения файлов и&nbsp;писем</p>
                        </li>
                        <li className={styles.item}>
                            <Icon28PictureOutline />
                            <p className={styles.text}>
                                С&nbsp;безлимитной автозагрузкой фото с&nbsp;телефона не&nbsp;займут&nbsp;место&nbsp;в&nbsp;Облаке
                                <span className={styles.labelNew}>
                                    <img src={`${imgNew}`} width={'100%'} height={'100%'} alt="Новое" />
                                </span>
                            </p>
                        </li>
                        <li className={styles.item}>
                            <Icon28CloudArrowUpOutline />
                            <p className={styles.text}>Сможете загружать очень тяжёлые файлы, до&nbsp;100&nbsp;гигабайт</p>
                        </li>
                    </ul>
                    <div className={styles.buttonWrapper}>
                        <Button
                            theme="vk"
                            onClick={handleClickByeButton}
                            sizeMode={ButtonSizeMode.big}
                            className={classNames({ [styles.btnLong]: cloudFullscreenD })}
                        >
                            {cloudFullscreenB && (
                                <>
                                    <span>Подключить за&nbsp;54&nbsp;₽ в&nbsp;месяц</span>
                                    <span className={styles.labelButton}>
                                        <img src={`${label73}`} className={styles.imageLabel} alt="экономия 73%" />
                                    </span>
                                </>
                            )}
                            {(cloudFullscreenC || cloudFullscreenE) && (
                                <>
                                    <span>Попробовать за&nbsp;1&nbsp;₽</span>
                                    <span className={styles.labelButton}>
                                        <img src={`${label30days}`} className={styles.imageLabel} alt="на 30 дней" />
                                    </span>
                                </>
                            )}
                            {cloudFullscreenD && (
                                <span>
                                    Подключите за&nbsp;<span className={styles.textDecoration}>199&nbsp;₽</span> 149&nbsp;₽ в&nbsp;месяц
                                </span>
                            )}
                        </Button>
                    </div>
                </div>
                <div className={styles.imgBox}>
                    <img src={`${imageCloud}`} className={styles.image} alt="Mail Space" />
                </div>
            </div>
        </Screen>
    );
});

export const renderFullScreenMonetization = (data?: FullScreenMonetizationProps) => {
    openPopupHelper({ popupName: popupNames.FULLSCREEN_CLOUD, data });
};

FullScreenMonetization.displayName = 'FullScreenMonetization';
